import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export const CITIES_FALLBACK = [
    "Manila",
    "Paranaque",
    "Muntinlupa",
    "Makati",
    "Taguig",
    "Pasig",
    "Quezon City",
    "Angeles City",
    "Baguio City",
    "Cebu City",
];

export const phpFmt = (n) =>
    new Intl.NumberFormat("en-PH", {
        style: "currency",
        currency: "PHP",
        maximumFractionDigits: 0,
    }).format(n || 0);

export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_office-hub-42/artifacts/gdl0zo0t_FWG%20Logo%20Final%202026.png";
